import { motion } from "framer-motion";
import { Seo } from "../components/Seo";

const VASARELY_HERO = "https://static.prod-images.emergentagent.com/jobs/ff5292f2-8fb8-452d-beeb-99c1c7548414/images/c1d99488cfa42556e3537fa94a4f4ad38e1f9f228b0c6af727f9d2ae16caa64c.png";

const GALLERY = [
  { url: "https://static.prod-images.emergentagent.com/jobs/ff5292f2-8fb8-452d-beeb-99c1c7548414/images/c1d99488cfa42556e3537fa94a4f4ad38e1f9f228b0c6af727f9d2ae16caa64c.png", artist: "Hommage à Victor Vasarely", note: "Op-art & illusion géométrique" },
  { url: "https://static.prod-images.emergentagent.com/jobs/ff5292f2-8fb8-452d-beeb-99c1c7548414/images/b1ca0ddeb8f156701fac14a1c698270a0878cd62e8f322310d50076536559b3c.png", artist: "Hommage à Andy Warhol", note: "Pop-art & sérigraphie" },
  { url: "https://static.prod-images.emergentagent.com/jobs/ff5292f2-8fb8-452d-beeb-99c1c7548414/images/41e57b868eadff952621a506892e716bb8d3f2ddfd429dd2104fcc29280a29cc.png", artist: "Hommage à Jean-Michel Basquiat", note: "Néo-expressionnisme" },
  { url: "https://static.prod-images.emergentagent.com/jobs/ff5292f2-8fb8-452d-beeb-99c1c7548414/images/b6e60ae8824b5c48bf1a931d8a2afe2c38d791b952002e2245a7f191df83242e.png", artist: "Hommage à Paul Gauguin", note: "Post-impressionnisme" },
  { url: "https://static.prod-images.emergentagent.com/jobs/ff5292f2-8fb8-452d-beeb-99c1c7548414/images/02b046a4cdcf9ed7d51f2cdc208a55e176840ce2dd519e656c66178cf0c73db1.png", artist: "Hommage à František Kupka", note: "Abstraction lyrique" },
];

const PARAGRAPHS = [
  "Bonjour, je suis moi-même handicapé (épileptique grave). « La Fondation des Artistes Handicapés » est pour tous les artistes, aussi bien handicapés que non handicapés. C'est un site gratuit, sans commission, qui permet aux artistes de partager leurs œuvres d'art, de protéger l'art et de le faire vivre, dans un monde dépassé par le capitalisme et les hautes technologies.",
  "Chaque artiste peut désormais mettre en vente ses œuvres d'art directement en ligne en se créant un compte, et il peut aussi les proposer aux enchères, qui durent 24 heures. Le site ne prend aucune commission : l'argent va directement à l'artiste.",
  "Les acheteurs peuvent payer par carte bancaire ou par virement pour les achats directs, et par PayPal pour les enchères — il faut aussi contacter le vendeur par message.",
  "La Fondation des Artistes Handicapés sert essentiellement à partager et à émerveiller. Dans un monde qui nous rend aveugles et ignorants, c'est aussi l'occasion de découvrir de nouveaux talents. Nous sommes encore assez peu nombreux pour l'instant, mais j'espère que beaucoup d'artistes nous rejoindront.",
  "Dans un monde où il faut payer 800 € pour exposer dans une galerie, avec 30 % de commission sur chaque tableau vendu, on ne peut pas dire qu'un artiste soit le plus riche du cimetière — et d'ailleurs, cela ne sert à rien. Alors profitons de la vie pour partager ensemble sur ce site.",
  "Le mépris n'a jamais rien apporté face à l'art et aux personnes handicapées. Je viens en aide à chaque artiste qui se trouve dans la même situation que moi : plus nous serons nombreux, plus nous irons loin, ensemble.",
  "J'ai créé ce site car j'ai l'impression que l'art est en train de disparaître, à mesure que la culture diminue. Il peut apporter une meilleure ouverture d'esprit. Je souhaite que, grâce à ce site, chaque artiste puisse vivre de son art.",
  "Merci pour votre aide et votre compréhension. Bonne journée à vous.",
  "Pour pouvoir acheter, vous devez renseigner votre carte bancaire, ou choisir le virement ou PayPal. Nous nous faisons une joie de vous accueillir sur le site La Fondation des Artistes Handicapés.",
];

export default function Information() {
  return (
    <div className="min-h-[100svh] bg-[#0a0a0f]" data-testid="information-page">
      <Seo
        title="Informations — La Fondation des Artistes Handicapés"
        description="L'art c'est la vie. Un site gratuit et sans commission pour partager l'art des artistes handicapés et non handicapés."
        path="/informations"
      />

      {/* Hero with Vasarely-style op-art */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src={VASARELY_HERO} alt="Op-art coloré" className="w-full h-full object-cover opacity-40" loading="eager" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-[#0a0a0f]/70 to-[#0a0a0f]" />
        </div>
        <div className="relative max-w-5xl mx-auto px-6 lg:px-10 pt-36 pb-20 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9 }}
            data-testid="information-title"
            className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight"
            style={{
              backgroundImage: "linear-gradient(95deg,#ff3d81,#ffd23f 35%,#23d5ab 65%,#3b82f6)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              textShadow: "0 2px 30px rgba(255,61,129,0.25)",
            }}
          >
            L'ART C'EST LA VIE
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.9, delay: 0.3 }}
            className="mt-6 text-zinc-300 italic text-lg"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
          >
            « Là où il n'y a pas d'espoir, nous devons l'inventer. »
          </motion.p>
        </div>
      </section>

      {/* Lyrical letter */}
      <section className="relative max-w-3xl mx-auto px-6 lg:px-8 py-16">
        <div
          className="relative rounded-sm p-8 sm:p-12"
          style={{
            background: "linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0.015))",
            boxShadow: "0 30px 80px -30px rgba(59,130,246,0.35), inset 0 1px 0 rgba(255,255,255,0.06)",
            borderTop: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <div className="absolute -top-px left-1/2 -translate-x-1/2 h-1 w-40"
            style={{ background: "linear-gradient(90deg,#ff3d81,#ffd23f,#23d5ab,#3b82f6)" }} />
          {PARAGRAPHS.map((p, i) => (
            <motion.p
              key={p.slice(0, 32)}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.04 }}
              className="text-zinc-200 leading-loose mb-6 text-lg"
              style={{
                fontFamily: "'Cormorant Garamond', Georgia, serif",
                textShadow: "0 1px 1px rgba(0,0,0,0.4)",
              }}
            >
              {p}
            </motion.p>
          ))}
          <p
            className="text-right mt-10 text-2xl text-[#ffd23f]"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontStyle: "italic" }}
          >
            — La Fondation des Artistes Handicapés
          </p>
        </div>
      </section>

      {/* Inspirations gallery */}
      <section className="max-w-6xl mx-auto px-6 lg:px-10 pb-28">
        <p className="text-xs uppercase tracking-[0.3em] text-[#23d5ab] mb-3 text-center">Inspirations</p>
        <h2 className="text-center font-display text-3xl sm:text-4xl text-white mb-3">Une ode à la couleur</h2>
        <p className="text-center text-zinc-400 max-w-2xl mx-auto mb-12 text-sm">
          Hommages picturaux aux grands mouvements qui nous inspirent — de l'op-art aux post-impressionnistes.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={g.artist}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="group relative overflow-hidden rounded-sm border border-white/10"
              data-testid={`inspiration-${i}`}
            >
              <img
                src={g.url}
                alt={g.artist}
                loading="lazy"
                className="w-full aspect-square object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/90 to-transparent">
                <p className="text-white font-medium text-sm">{g.artist}</p>
                <p className="text-zinc-400 text-xs">{g.note}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </section>
    </div>
  );
}
